export const formatCurrencyInRands = (amount) => {
  if (!amount) {
    return `R${0}`;
  }

  return `R${amount.toFixed(2)}`;
};
